import { useCallback, useContext } from "react"
import { useConfigurationModule } from "../Settings/Configuration/hooks/useConfigurationModule";
import { ProfileContext } from "./context";

export const useIsFieldDisabled = (module) => {
    const config = useConfigurationModule(module);
    const { user } = useContext(ProfileContext);
    const getIsFieldDisabeld = useCallback((key) => {
        return !config?.[key] && user?.isApi;
    }, [config, user?.isApi]);
    return getIsFieldDisabeld;
}
